import React from 'react';
import CountView from '../CountView/CountView';
import { useSelector } from 'react-redux';
import useFlatStagesCount from '../../../../../../hooks/useFlatStagesCount';

const FlatStagesCountView = ({ gridData = [] }) => {
  const monitoringStage = useSelector(
    (state) => state.housingStockStore.monitoringStage
  );

  const values = useFlatStagesCount(gridData, monitoringStage);

  return (
    <CountView
      values={values}
      isSquare
      isBorder
    />
  );
};

export default FlatStagesCountView;
